<template>
  <section class="homelab-appointments">
    <Breadcrumbs
      :breadcrumbs="[
        { title: $t('menu.homelab'), disabled: true },
        { title: $t('homelab.appointments'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2"
          :querySearch.sync="querySearch" />

        <Filters
          class="mr-2"
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />

        <va-popover
          placement="left"
          :message="$t('leads.download')">
          <span class="i-cloud-download" @click.prevent="downloadAppointments"></span>
        </va-popover>
      </div>
    </Breadcrumbs>

    <div class="btn btn__floating btn__round__large" v-if="hasWriteAppointmentsPermissions">
      <va-popover
        placement="left"
        :message="$t('homelab.buttons.new_appointment')"
      >
        <va-button
          key="btn-create-person"
          color="success"
          @click="isCreatingAppointment = true">
          <i class="fa fa-plus"></i>
        </va-button>
      </va-popover>
    </div>

    <AppointmentsTable
      ref="homelabAppointmentsTable"
      :querySearch="querySearch"
      :showFilters="showFilters"
      @filters-updated="onFiltersUpdated"
      @appointment-selected="onAppointmentSelected"
    >
    </AppointmentsTable>

    <create-or-update-appointment v-if="isCreatingAppointment"
      @appointment-created="onAppointmentCreated"
      @cancel="isCreatingAppointment = false"
    >
    </create-or-update-appointment>

  </section>
</template>

<script>
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'
import AppointmentsTable from './AppointmentsTable.vue'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import { AppointmentService } from '@/api/HomelabService'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import CreateOrUpdateAppointment from './CreateOrUpdateAppointment.vue'
import { TABLE_HOMELAB_APPOINTMENTS } from '@/local-storage/LocalStorageKeys'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [
    IndexTablesMixin
  ],
  components: {
    Filters,
    Searchable,
    Breadcrumbs,
    AppointmentsTable,
    CreateOrUpdateAppointment
  },
  data: function () {
    return {
      isCreatingAppointment: false,
      localStorageKey: TABLE_HOMELAB_APPOINTMENTS,
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
    }
  },
  computed: {
    homelabService: function () {
      return this.component.service
    },
    hasWriteAppointmentsPermissions: function () {
      return this.homelabService.user_permissions.some(permission => permission.access_type >= 2 && permission.info_type === 100)
    }
  },
  created: function () {
    this.$store.dispatch('homelab/INITIALIZE_MODULE')
  },
  methods: {
    onAppointmentSelected: function (appointment) {
      this.showAppointmentDetails(appointment)
    },
    onAppointmentCreated: function (appointment) {
      // this.$refs.homelabAppointmentsTable.refresh()
      this.showAppointmentDetails(appointment)
    },
    showAppointmentDetails: function (appointment) {
      this.$router.push({ name: `${this.serviceSlug}homelab/appointments/id`, params: { id: appointment.id } })
    },
    downloadAppointments: function () {
      let activeFilters = this.$refs.homelabAppointmentsTable.getActiveFilters()
      AppointmentService.downloadAppointments(activeFilters)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'appointments.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch(errors => this.showToast(this.$t('homelab.something_went_wrong'), this.$store.state.errorToastOptions))
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    }
  },
  watch: {
    activeFilters: function (count) {
      this.showFilters = count > 0
    }
  }
}
</script>
